/**
 * Главная — копия legacy main_index.tpl: слайдер .rtSlider + материал 'main'.
 *
 * Логика слайдера повторяет assets/js/rtSlider.js (jQuery-плагин, в шаблоне его нет):
 *   — автосмена каждые 5 секунд;
 *   — под слайдами блок .ctrl с точкой-ссылкой на каждый слайд, активная — .act;
 *     клик по точке переключает слайд;
 *   — точки появляются только если слайдов больше одного;
 *   — слайдов нет вовсе — блок .rtSlider не рисуется (в legacy его удалял JS).
 * Разметка и классы — те же, что ждёт assets/css/rtSlider.css.
 */

import { useEffect, useState } from 'react'

import type { Material } from '@/api/types'
import { useLegacyCss } from '@/lib/legacyAssets'
import { useApi } from '@/lib/useApi'

interface HomeData {
  slides: { id: number; name: string }[]
  slide_h: number
  material: Material | null
}

export function HomePage() {
  // legacy Main::index добавлял 'rtSlider' и в $data.css, и в $data.js — стили слайдера
  // лежат отдельным файлом и глобально не подключены (assets/css/rtSlider.css)
  useLegacyCss('rtSlider')

  const { data } = useApi<HomeData>('/api/content/index')
  const slides = data?.slides ?? []
  const height = data?.slide_h ?? 400
  const [index, setIndex] = useState(0)

  // legacy rtSlider: смена слайда раз в 5 секунд
  useEffect(() => {
    if (slides.length < 2) return
    const timer = setInterval(() => setIndex((i) => (i + 1) % slides.length), 5000)
    return () => clearInterval(timer)
  }, [slides.length])

  return (
    <>
      <br />
      {slides.length > 0 && (
        <div className="rtSlider">
          <div className="cont" style={{ height: `${height}px` }}>
            {slides.map((slide, i) => (
              <div
                key={slide.id}
                className="slideimg"
                style={{
                  background: `url('/slides/${slide.name}') 100%`,
                  backgroundSize: 'cover',
                  height: `${height}px`,
                  maxHeight: `${height}px`,
                  width: '100%',
                  display: i === index ? 'block' : 'none',
                }}
              />
            ))}
          </div>
          {slides.length > 1 && (
            <div className="ctrl">
              {slides.map((slide, i) => (
                <a
                  key={slide.id}
                  className={i === index ? 'act' : undefined}
                  onClick={() => setIndex(i)}
                >
                  &nbsp;
                </a>
              ))}
            </div>
          )}
        </div>
      )}
      {data?.material != null && <div dangerouslySetInnerHTML={{ __html: data.material.text }} />}
    </>
  )
}
